angular.module('rjmNg.directives').directive "filterSetDetails", [
  () ->
    restrict: "E"
    templateUrl: "directive.filterSetDetails.html"
    replace: true
    bindToController: true
    controllerAs: 'view'
    scope:
      filterSet: "="
      showDependentsOnly: "="
    controller: [
      "notification"
      "app"
      "StructureCache"
      "errorConstants"
      "encodedLetterString"
      "FilterSets"
      "dependencyEnums"
      "$routeParams"
      "operatorEnums"
      (
        notification
        app
        StructureCache
        errorConstants
        encodedLetterString
        FilterSets
        dependencyEnums
        $routeParams
        operatorEnums
      ) ->
        view = @

        view.isAdmin = app.isAdminUser()
        view.loading = true
        view.clientId = $routeParams.clientId
        view.encodedLetterString = encodedLetterString
        view.showNoDependents = false

        view.expansionLoading = false
        notificationTimeout = 15

        view.operationIdToName = (operation) ->
          operationIdentifier = operatorEnums.SCHEMA_SERVICE_COMPARISON_OPERATOR_IDS[operation]
          operatorEnums.COMPARISON_OPERATOR_SYMBOLS[operationIdentifier]

        view.getDependencyName = (dependencyId) ->
          return dependencyEnums.RESOURCE_DEPENDENCIES[dependencyId]

        _showError = () ->
          notification.error("Server Error", errorConstants.SERVER_ERROR_MESSAGE, "filterSets", null, notificationTimeout)

        _loadStructure = ->
          StructureCache.getStructure().then(
            (structure) ->
              view.structure = structure
              view.loading = false
            , (error) ->
              _showError()
          )

        view.loadDependents = () ->
          view.expansionLoading = true
          FilterSets.dependents(view.clientId, view.filterSet.id).then(
            (dependents) ->
              view.filterSet.dependents = dependents
              # Because Resource object by default has two keys: $promise and $resolved
              view.showNoDependents = if Object.keys(dependents).length > 2 then false else true
              view.expansionLoading = false
            , (error) ->
              _showError()
          )

        @$onInit = () ->
          if view.showDependentsOnly
            view.loading = false
            view.loadDependents()
          else
            _loadStructure()

        return view
    ]
]
